// extracted by mini-css-extract-plugin
var _1 = "recipient_container__P2vjl";
var _2 = "recipient_names__A6ie4";
var _3 = "recipient_recipientsInformation__y9vcl";
export { _1 as "container", _2 as "names", _3 as "recipientsInformation" }
